<span class="overlay"></span>
<div class="spinner-container">
  <span class="spinner"></span>
  <h3 class="title">{{ title | async }}</h3>
</div>
